module.exports = __webpack_public_path__ + "static/media/ChangEFactoryINTA0003_design_clean_v003.91dfde66.png";